import { HttpHandler } from '../HttpHandler';
import { environment } from '../../enviroments';
import { ISpecialist } from '../../redux/specialists/types';
import { Specialist } from '@mindly/ui-components';

export const getSpecialistByID = async (specialistID: string): Promise<ISpecialist> => {
  const { data: specialistData } = await HttpHandler({
    method: 'GET',
    url: `${environment.SPECIALIST_URL}/client/${specialistID}`,
  });

  return specialistData.data;
};

export const getSpecialistBySlug = async (slug: string): Promise<ISpecialist> => {
  const { data: specialistData } = await HttpHandler({
    method: 'GET',
    url: `${environment.SPECIALIST_URL}/by-slug/${slug}`,
  });

  return specialistData.data;
};

export const getSpecialistTotal = async (filters: string): Promise<number> => {
  const { data: response } = await HttpHandler({
    method: 'GET',
    url: `${environment.SPECIALIST_APP_URL}/specialists/total?filters=${filters}`,
  });

  return response.data;
};

export const getSpecialistsByIDs = async (ids: string[]): Promise<Specialist[]> => {
  const { data: response } = await HttpHandler<{ data: Specialist[] }>({
    method: 'GET',
    url: `${environment.SPECIALIST_APP_URL}/specialists/by-ids`,
    params: {
      ids,
    },
  });

  return response.data;
};
